<div class="availabilty-wrapper">
  <div class="desav-container first">
    <div class="selector-div-wrapper">
      <p class="title">RANDOM SEAT AVAILABILITY</p>
      <!-- <div class="selector-div">
          <select name="selector" class="selector" [(ngModel)]="tool.enabled">
            <option [ngValue]="true">Si</option>
            <option [ngValue]="false">No</option>
          </select>
          <div class="vertical-line"></div>
        </div> -->
      <div class="form-check form-switch">
        <input class="input-switch-sm form-check-input" type="checkbox" role="switch" id="searcher-switch"
          (click)="randomAvailability()" [(ngModel)]="tool?.random.enabled" [checked]="tool?.random.enabled" />
      </div>
    </div>
    <input type="range" min="1" max="9" [(ngModel)]="randomvalue" (change)="randomUpdate($event)"
      [disabled]="!tool.random.enabled" />
  </div>
  <div class="upload-file-container">
    <p class="title mt-2">
      <span>Habilitar / Deshabilitar via JSON</span>
    </p>
    <p>
      <small *ngIf="tool.unavailableNodesList">
        Se sobrescribirán todos los ID
      </small>
    </p>
    <div class="file-content" *ngIf="!postedFile; else fileExisting" (fileDrop)="onFileDropped($event)" fileDropZone>
      <p class="text-drag-file">Arrastra el archivo aquí</p>
      <p class="text-drag-file divisor">— o —</p>
      <input type="file" class="file-uploader" (change)="onFileSelected($event)" #fileUpload />
      <button class="upload-file-btn" (click)="fileUpload.click()">
        Seleccionar archivo de tu ordenador
      </button>
    </div>
    <a class="btn-transparent" [href]="downloadTemplate" download="availability_template.json">Descargar plantilla</a>

    <ng-template #fileExisting>
      <div class="file-content active">
        <div class="file-box">
          <span *ngIf="postedFile && postedFile.name">{{
            postedFile.name
            }}</span>
          <button class="element-action-btn" (click)="deleteDroppedFile()">
            <img id="delete" alt="" />
          </button>
        </div>
        <div class="jsonviewer-wrapper" *ngIf="tool.unavailableNodesList">
          <!--
                        <json-editor [options]="editorOptions" [data]="tool.fileData" (change)="showEditorPreview($event)"></json-editor>
                    -->

          <ngx-json-viewer *ngIf="tool.unavailableNodesList" [json]="tool.unavailableNodesList"
            [expanded]="false"></ngx-json-viewer>
        </div>
      </div>
    </ng-template>
  </div>
  <div class="desav-container">
    <p class="title">Habilitar / Deshabilitar manualmente</p>
    <div class="selector-div-wrapper">
      <span>Activar</span>
      <div class="form-check form-switch">
        <input class="input-switch-sm form-check-input" type="checkbox" role="switch" id="availability-switch"
          (change)="onSelectManual()" [(ngModel)]="manualAvailability" [checked]="manualAvailability" />
      </div>
    </div>
  </div>
  <div class="clean-contanier">
    <button class="btn-secondary-action me-auto" (click)="cleanAll()">
      Limpiar y Habilitar todo
    </button>
    <!-- <button class="btn-secondary-action ms-auto" (click)="apply()">Aplicar cambios</button> -->
  </div>
</div>